import axios from 'axios';

import IdentityService from './identity.service.jsx';
import ContactService from './contact.service';

const apiUrl = `${process.env.REACT_APP_API_URL}/api/2.0`;

export default function (resourceCenter) {
  axios.interceptors.request.use(function (config) {
    if (config.url.startsWith(apiUrl)) {
      config.headers['PF-IDENTITY'] = IdentityService.getFingerprint();
      if(resourceCenter) {
        var token = ContactService.getToken(resourceCenter);
        
        if (token) {
          config.headers['PF-TOKEN'] = token;
        }
      }
    }

    return config;
  });
}